// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { Flex, Modal, UseShowHide } from '@teamnine/pcj-ui-v2'

import { Template as ITemplate } from '@/services/templates'
import TemplateJSON from '@/app/Templates/components/TemplateJSON'

type ViewTemplateModalProps = {
  modal: UseShowHide
  template?: ITemplate
}

export default function ViewTemplateModal({
  modal,
  template,
}: ViewTemplateModalProps) {
  return (
    <Modal open={modal.visible} onOpenChange={modal.toggle}>
      <Modal.Display aria-label="View Template JSON">
        <Modal.Header title="View Template JSON" />
        <Modal.Content>
          <Flex direction="column" gap={16}>
            <TemplateJSON templateId={template?.id ?? ''} />
          </Flex>
        </Modal.Content>
        <Modal.Footer
          footerAction={{
            primaryButton: {
              label: 'Close',
              type: 'button',
              closeModal: true,
            },
          }}
        />
      </Modal.Display>
    </Modal>
  )
}
